var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"pt-0 mt-0 mb-4",attrs:{"id":`form-checkbox-${_vm.tag.name}`,"inset":"","false-value":"0","true-value":"1","readonly":_vm.readonly,"label":_vm.tag.description,"hide-details":""},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }